import { useEffect } from "react";
import { useSnapshot } from "valtio";
import Head from "next/head";
import router, { useRouter } from "next/router";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";

import { UnitNav } from "components/elements/UnitNav";
import { ProjectList } from "components/elements/ProjectList";
import { Text } from "components/ui/Text";
import { Layout } from "components/ui/Layout";
import { Spinner } from "common/ui/Spinner";

import store, { setProjectId, setPurchaseOfferId } from "common/middleware/store";
import { useProperties } from "common/middleware/hooks";

export default function Home() {
  const snapshot = useSnapshot(store);
  const { locale } = useRouter();
  const { properties } = useProperties({ projectId: snapshot.currentProjectId });
  const { t } = useTranslation("checkout");

  useEffect(() => {
    const url = window.location.origin;

    if (!snapshot.isDevEnv) {
      if (url.includes("dumusee")) {
        router.push(
          `https://dumusee.com/${
            locale === "en-US" ? "en" : "fr"
          }/reserve-your-unit`
        );
      } else if (url.includes("royalquai")) {
        window.location.href = "https://royalquai.ca";
      }
    }
  }, [snapshot]);

  return (
    <Layout.PageFrame>
      <Head>
        <title>OwnSpace</title>
        <meta
          name="description"
          content={t("pages.index.purchaseCustom")}
        />
        <meta name="viewport" content="width=500" />
        <link rel="icon" href="/favicon.ico" />
      </Head>

      {snapshot.isDevEnv ? (
        snapshot.currentProjectId ? (
          properties ? (
            <>
              <UnitNav properties={properties} />
              {window.location.origin.includes("localhost") && (
                <Text.SmallBlue onClick={() => {
                  setProjectId(null);
                  setPurchaseOfferId(undefined, undefined);
                }}>
                  Change project
                </Text.SmallBlue>
              )}
            </>
          ) : (
            <Spinner />
          )
        ) : (
          <ProjectList />
        )
      ) : (
        <Spinner />
      )}
    </Layout.PageFrame>
  );
}

export const getStaticProps = async ({ locale }) => {
  return {
    props: {
      ...await serverSideTranslations(locale, ["checkout"]),
    }
  }
}
